import { render, staticRenderFns } from "./BackgroundBeam.vue?vue&type=template&id=719fac44&lang=html"
import script from "./BackgroundBeam.vue?vue&type=script&lang=js"
export * from "./BackgroundBeam.vue?vue&type=script&lang=js"
import style0 from "./BackgroundBeam.vue?vue&type=style&index=0&id=719fac44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports